/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.not-in-session'},
});

const NotInSessionItem = () => (
  <RouteLinkItem
    route="midas/settings/calendar/not-in-session"
    title={messages.title}
  />
);

export default NotInSessionItem;
